import { useEffect, useState, useCallback } from "react";
import { getDocumentTemplatesURL } from "../utils/ConstantsURL";

export const useGetDocumentTemplates = (token) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response = await fetch(getDocumentTemplatesURL(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      let data = await response.json();
      if (response.ok && data.success) {
        setTemplates(data.templates || []);
      } else {
        throw new Error(data.message || "Error al obtener plantillas");
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { templates, loading, refetch: fetchData };
};
